module.exports = __webpack_public_path__ + "static/media/layout7-img.5965a3ab.svg";